enum UIMode {
  Legacy = 'legacy',
  New = 'new',
}

export default UIMode;
